import apiClient, {timeouts} from 'shared/services/apiClient';
import {LogType, LogResp} from "../types";
import {endpoints} from "shared/services/endpoints";

export const logsService = {
    getLog: async (level: LogType, lines: number = 100, include_older: boolean = false) => {
        return apiClient
            .get<LogResp>(endpoints.logs.byLevel(level, lines, include_older), {timeout: timeouts.simpleOperationsTimeout})
            .then(r => r.data as LogResp)
            .catch((reason) => {
                return {level: level, log: [], errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as LogResp;
            }
        );
    }
};
